import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Rafraîchir / synchroniser — flèches circulaires duotone */
export const RefreshIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Arc supérieur (menthe) */}
      <path
        d="M3.5 12a8.5 8.5 0 0 1 14.5-6"
        stroke="var(--equiply-icon-bg)" strokeWidth="2.5" strokeLinecap="round"
      />
      {/* Arc inférieur bleu */}
      <path
        d="M20.5 12a8.5 8.5 0 0 1-14.5 6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round"
      />
      {/* Flèche haut-droite */}
      <path
        d="M14 3.5L18 6l-2.5 4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Flèche bas-gauche */}
      <path
        d="M10 20.5L6 18l2.5-4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
RefreshIcon.displayName = "RefreshIcon";
